(function (Drupal) {
  Drupal.behaviors.datepickerInit = {
    attach: function (context, settings) {

      once('datepicker-init', '.form-item-field-event-date-value input').forEach(el => {
        flatpickr(el, {
          altInput: true,
          altFormat: "j. F Y",
          dateFormat: "Y-m-d",
          "locale": "de"
        });
      });

    }
  }
})(Drupal);
